import GrainOutlinedIcon from '@mui/icons-material/GrainOutlined';

/**
 * Escala de Bristol: forma e consistência das fezes, do tipo 1 ao 7.
 * Referência clínica: Lewis & Heaton (1997) e a validação brasileira de
 * Martinez & Azevedo (Rev. Latino-Am. Enfermagem, 2012). Sete cartões sem
 * faixas de grupo; a leitura de cada tipo fica na ajuda. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/bristol.php.
 */
const bristol = {
  key: 'bristol',
  name: 'Escala de Bristol',
  description: 'Forma e consistência das fezes, do tipo 1 ao 7',
  details: 'Classifica as fezes pela forma e consistência, do tipo 1 (pedaços duros e separados) ao 7 (totalmente líquidas). Os tipos 1 e 2 sugerem trânsito intestinal lento, e os tipos 6 e 7, trânsito acelerado. Ajuda a acompanhar o funcionamento intestinal em planos alimentares, suplementação e tratamentos. Um clique marca o tipo do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: GrainOutlinedIcon,
  accent: 'green',
  options: [
    { value: '1', label: 'Tipo 1', caption: 'Bolinhas duras', image: 'bristol-1.png', help: 'Pedaços duros e separados, difíceis de eliminar. Sugere trânsito intestinal lento.' },
    { value: '2', label: 'Tipo 2', caption: 'Alongada e encaroçada', image: 'bristol-2.png', help: 'Formato alongado, mas firme e com caroços. Sugere trânsito intestinal lento.' },
    { value: '3', label: 'Tipo 3', caption: 'Alongada com rachaduras', image: 'bristol-3.png', help: 'Formato alongado, com rachaduras na superfície. Considerada dentro do habitual.' },
    { value: '4', label: 'Tipo 4', caption: 'Alongada e lisa', image: 'bristol-4.png', help: 'Formato alongado, liso e macio. Considerada a forma de referência.' },
    { value: '5', label: 'Tipo 5', caption: 'Pedaços macios', image: 'bristol-5.png', help: 'Pedaços macios com bordas bem definidas, fáceis de eliminar. Pode indicar trânsito um pouco acelerado.' },
    { value: '6', label: 'Tipo 6', caption: 'Pastosa', image: 'bristol-6.png', help: 'Pedaços moles, de bordas irregulares, de consistência pastosa. Sugere trânsito intestinal acelerado.' },
    { value: '7', label: 'Tipo 7', caption: 'Líquida', image: 'bristol-7.png', help: 'Totalmente líquida, sem partes sólidas. Sugere trânsito intestinal muito acelerado.' },
  ],
};

export default bristol;
